import { useEffect, useState } from "react";

import "./map.css";

const Map = ({ data }) => {
  const [topology, setTopology] = useState();
  useEffect(() => {
    let active = true;

    const fetchTopology = async () => {
      try {
        const response = await fetch(
          "https://code.highcharts.com/mapdata/countries/id/id-all.topo.json",
        );

        if (!response.ok) {
          throw new Error(
            `Failed to load Indonesia map topology: HTTP ${response.status}`,
          );
        }

        const topologyRes = await response.json();

        if (active) {
          setTopology(topologyRes);
        }
      } catch (error) {
        console.error(
          "Failed to load Indonesia map topology:",
          error,
        );
      }
    };

    fetchTopology();

    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (topology) {
      // Create the chart
      window.Highcharts.mapChart(
        "map-container",
        {
          chart: {
            map: topology,
          },

          title: {
            text: "",
          },

          mapNavigation: {
            enabled: true,
          },

          colorAxis: {
            min: 0,
            max: 100,
          },
          
          tooltip: {
            formatter: function() {
              return `<b>${this.point.name}</b>: ${this.point.value}%`;
            }
          },
          
          series: [
            {
              data: data,
              name: "",
              states: {
                hover: {
                  color: "#BADA55",
                },
              },
              dataLabels: {
                enabled: true,
                format: "{point.name}",
                nullFormat: "",
              },
            },
          ],
        },
        ...(data?.length === 1
          ? [
              (chart) => {
                if (chart?.series) {
                  for (const country of chart.series[0].data) {
                    if (Boolean(country?.value)) {
                      country.zoomTo();
                    }
                  }
                }
              },
            ]
          : []),
      );
    }
  }, [data, topology]);

  return <div id='map-container' className='highcharts-light'></div>;
};

export default Map;
